module.exports = __webpack_public_path__ + "static/media/ZFTC.8315ba34.pdf";